import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Activar tema accesible claro por defecto
if (typeof document !== 'undefined') {
  document.documentElement.classList.add('theme-accessible-light')
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)